export function StaticTooltip({ content, placement = "bottom", children }) {
  const placementClass = {
    bottom: "top-full mt-2 left-1/2 -translate-x-1/2",
    top: "bottom-full mb-2 left-1/2 -translate-x-1/2",
  };

  return (
    <span className="relative inline-block group">
      {children}
      <span
        className={`pointer-events-none absolute z-10 whitespace-nowrap rounded-lg bg-gray-900 px-3 py-2 text-xs font-medium text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100 dark:bg-gray-700 ${placementClass[placement]}`}
      >
        {content}
      </span>
    </span>
  );
}
